import { baseAPI } from '../index';

interface CreateChatRequest {
  uuId: string;
  text: string;
}

const createChat = async ({ uuId, text }: CreateChatRequest) => {
  const url = `/comment/${uuId}/create`;
  const requestBody = {
    text,
  };
  const response = await baseAPI.post(url, requestBody, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization:
        typeof window !== 'undefined'
          ? `Bearer ${localStorage.getItem('token')}`
          : '',
    },
  });
  return response;
};
export default createChat;
